import BaseFilter from "./base_filter"
import { createElement, createFormGroup, createSummary } from "./dom"

const createTimeInput = () => {
  const input = createElement("input", { className: "form-control filter-time-span__input" })
  input.type = "text"
  return input
}

const createTimeControl = (hoursInput, minutesInput) => {
  const wrapper = createElement("div", { className: "filter-time-span__wrapper" })
  wrapper.append(hoursInput, createElement("span", { className: "filter-time-span__colon", text: ":" }), minutesInput)
  return wrapper
}

export default class TimeSpanFilter extends BaseFilter {
  createForm() {
    super.createForm()

    this.fromHours = createTimeInput()
    this.fromMinutes = createTimeInput()
    this.toHours = createTimeInput()
    this.toMinutes = createTimeInput()

    this.element.append(
      createElement("label", { text: this.definition.title }),
      document.createElement("br"),
      createFormGroup(this.definition.labels.from, createTimeControl(this.fromHours, this.fromMinutes)),
      createFormGroup(this.definition.labels.to, createTimeControl(this.toHours, this.toMinutes)),
    )
    this.appendApplyButton()

    return this.element
  }

  read() {
    const from = `${this.fromHours.value || "12"}:${this.fromMinutes.value || "00"}`
    const to = `${this.toHours.value || "12"}:${this.toMinutes.value || "00"}`
    return this.result([from, to])
  }

  summary(value) { return createSummary(this.definition.title, `${value[0]} - ${value[1]}`) }
}
